import { getFilenameFromResponse } from '../components/vendors/UploadedFile';

const EXT_TO_MIME = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

const downloadFile = async (fileType, setFilePreview, authAxios, id) => {
  setFilePreview((prev) => ({ ...prev, downloading: true }));
  try {
    const response = await authAxios.get(`files/download?id=${id}&type=${fileType}`, {
      responseType: 'blob',
    });
    const filename = getFilenameFromResponse(response);
    const ext = filename.split('.').pop().toLowerCase();
    const blob = new Blob([response.data], {
      type: EXT_TO_MIME[ext] ?? 'application/octet-stream',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    setFilePreview((prev) => ({
      ...prev,
      url,
      isOpen: true,
      fileType: ext,
    }));
  } catch (error) {
    console.error(error);
  } finally {
    setFilePreview((prev) => ({ ...prev, downloading: false }));
  }
};

export default downloadFile;
